export default __webpack_public_path__ + "static/meta_image-80a2b4695ebab76d90d61208edf5ed56.png";